import wtjd from "./pages/index.vue";

export default {
  path: "/wtjd",
  component: wtjd,
  children: [],
};



// WEBPACK FOOTER //
// ./src/views/wtjd/router.js